import React, { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button, { ButtonProps } from 'vibo-ui/Button';

import { IconmoonFont } from 'vibo-ui/Icon';

const CollapseExpandSectionsButton: FC<ButtonProps> = ({ ...rest }) => {
  const { t } = useTranslation();

  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSectionCollapsed = useCallback(() => setIsCollapsed(!isCollapsed), [isCollapsed]);

  const sectionsTimelineScroll = document.getElementById('sectionsTimelineScroll');

  useEffect(() => {
    isCollapsed
      ? sectionsTimelineScroll?.classList.add('collapsed')
      : sectionsTimelineScroll?.classList.remove('collapsed');
  }, [isCollapsed]);

  return (
    <Button
      onClick={toggleSectionCollapsed}
      prefixIcon={IconmoonFont[isCollapsed ? 'expand-16' : 'collapse-16']}
      tooltipProps={{
        overlay: t(isCollapsed ? 'Expand sections' : 'Collapse sections'),
        fillOverlay: true,
        placement: 'top',
      }}
      displayType="bordered"
      shape="round"
      size="lg"
      {...rest}
    >
      {t(isCollapsed ? 'expand' : 'collapse')}
    </Button>
  );
};

export default CollapseExpandSectionsButton;
